<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("view") }} {{ $tc("hardware", 2) }} {{ $tc("setting", 2) }}
      </div>
      <div>
        <router-link
          class="btn-blue"
          :to="{
            path: '/cinema-manager/edit-hardware-settings',
            query: { id: this.hs_id },
          }"
          >{{ $t("edit") }}</router-link
        >
        <router-link class="btn-blue" to="hardware-settings"
          >{{ $tc("hardware", 2) }} {{ $tc("setting", 2) }}
          {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div v-for="(item, index) in hardwareSetting" :key="index" class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("select") }} {{ $tc("cinema", 1) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ item.cine_name }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("select") }} {{ $tc("hardware", 1) }} {{ $tc("type", 1) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ item.h_name }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("username") }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ item.hs_username }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("password") }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ item.hs_password }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("hardwareuniquecode") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ item.hs_cpu_id }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("hardware", 2) }} {{ $t("name") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ item.hs_hardware_name }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("noteremarks") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ item.hs_remarks }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("connectionport") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ item.hs_connection_port }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("installedby") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ item.hs_installed_by }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("installedat") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ item.hs_installed_at | dateparse }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("status", 1) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ item.hs_is_active == "Y" ? $t("active") : "" }}
              </div>
            </div>
          </div>

          <div
            v-if="login_user_role_id === 1"
            class="col-md-12 py-2 border-bottom"
          >
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("createdby") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <!-- <span>{{ $tc('ho', 1) }} {{ $t('manager') }}</span> -->
                <span>{{ item.created_by }}</span>
              </div>
            </div>
          </div>

          <div
            v-if="login_user_role_id === 1"
            class="col-md-12 py-2 border-bottom"
          >
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("createdat") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{ item.created_at | dateparse }}</span>
                <!-- <span class="mr-3">06/04/2019</span>
                <span>12:05 AM</span>-->
              </div>
            </div>
          </div>

          <div
            v-if="login_user_role_id === 1"
            class="col-md-12 py-2 border-bottom"
          >
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("modifiedby") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span>{{ item.updated_by }}</span>
                <!-- <span>{{ $tc('ho', 1) }} {{ $t('manager') }}</span> -->
              </div>
            </div>
          </div>

          <div v-if="login_user_role_id === 1" class="col-md-12 py-2">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("modifiedat") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{ item.updated_at | dateparse }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";

export default {
  data() {
    return {
      login_user_role_id: null,
      hardwareSetting: [],
      hs_id: null,
    };
  },
  beforeMount() {
    const { id } = this.$route.query;
    if (id) {
      this.getHardwareDetails(id);
      this.hs_id = id;
    } else {
      this.$router.go(-1);
    }
    const { role_id } = this.secureStore.get("USINFO");
    this.login_user_role_id = role_id;
  },
  mounted() {},
  methods: {
    getHardwareDetails: function (hs_id) {
      CinemasService.GetHardwareSettignsById({ hs_id })
        .then((response) => {
          const { data } = response;
          console.log("data :", data);
          if (data && data.status && data.Records.length > 0) {
            this.hardwareSetting = data.Records;
            this.hs_id = data.Records[0].hs_id
              ? data.Records[0].hs_id
              : this.hs_id;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/HardwaresComponents/viewHardwareSettings.vue